import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useTheme } from "@mui/material";


export default function CardMarkerSuperLong(props) {
  
  const theme = useTheme();
  const {headline, subtext, cardlines } = props

return(
<>

{theme.palette.mode === "light" ? (

  <Card variant="outlined" sx={{ width: {xs: 480, sm: 640, md: 820, lg: 920, xl: 1050}, height: 'auto', 
                                 bgcolor: 'grey.C50', borderColor: 'grey.C900', borderRadius: "12px",  
                                m:2, p:1
                                }}>
      <CardContent>
   
        <Grid container >
       
             <Grid size={12}> <Typography variant="h3" textAlign='left' gutterBottom sx={{color: 'common.black', }}>{headline} </Typography>  </Grid>
             <Grid size={12}> <Typography variant="subtitle2" textAlign='left' gutterBottom sx={{pl: 0.5,color: 'common.black', fontWeight: 300,}}>{subtext} </Typography>  </Grid>
            <Grid size={12}>{ cardlines }</Grid>  
      </Grid>        
 
  </CardContent>
  </Card>

):(

  <Card variant="outlined" sx={{  width: {xs: 480, sm: 640, md: 820, lg: 920, xl: 1050}, height: 'auto', 
                                  bgcolor: 'greydark.C300', borderColor: 'greydark.C400', borderRadius: "12px", 
                                  m:2, p:1
                                    }}>
   <CardContent>

      <Grid container>   
     
             <Grid size={12}> <Typography variant="h3" textAlign='left' gutterBottom sx={{color: 'common.white', }}>{headline} </Typography>  </Grid>
            <Grid size={12}> <Typography variant="subtitle2" textAlign='left' gutterBottom sx={{pl: 0.5,color: 'common.whitek', fontWeight: 300,  }}>{subtext} </Typography>  </Grid>
            <Grid size={12}>{ cardlines }</Grid>  

     </Grid>        

</CardContent>
</Card>

)}

</>
)
}

